import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {readEndpoint} from 'redux-json-api'

import Modals from '../../../../shared_components/core/modals/Modals'
import {ModalHeader} from '../../../../shared_components/core/modals/ModalHeaders'
import Closer from '../../../../shared_components/core/closer/Closer'
import PreneedPaymentFormController from './PreneedPaymentFormController'
import routerUtils from '../../../../lib/routerUtils'
import {accountSettingsUrl} from '../../../../lib/urlTools'

import './preneedPaymentModal.scss'

export const PreneedPaymentModal = ({onSuccess, location = {}, ...otherProps}) => {
  const goToPreviousOrAccountSettingsRoute = () => {
    const prevPath = location.query?.prevPath

    if (prevPath)
      return routerUtils.push(prevPath)

    return routerUtils.setLocation(accountSettingsUrl)
  }

  const handleSuccess = () => {
    otherProps.readEndpoint('user-configs').then(() => {
      if (onSuccess)
        onSuccess()
      else
        goToPreviousOrAccountSettingsRoute()
    })
  }

  const modalCloser = () => (<Closer closer={goToPreviousOrAccountSettingsRoute} />)

  return (
    <Modals.LinkPopUpModalLarge
      className='preneed-payment-modal'
      closerComponent={modalCloser}
      showModalOnMount={true}>
      <ModalHeader heading='Get lifetime access for just $299' />
      <div className='preneed-payment-modal__content'>
        <div className='preneed-payment-modal__prompt'>
          Enter your credit card below to upgrade to Lifetime Premium.
        </div>
        <div className='preneed-payment-modal__sub-prompt'>
          One payment, yours forever (vs. $99/year annually)
        </div>
        <PreneedPaymentFormController
          onSuccess={handleSuccess}
        />
      </div>
    </Modals.LinkPopUpModalLarge>
  )
}

PreneedPaymentModal.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      prevPath: PropTypes.string
    })
  }),
  onSuccess: PropTypes.func,
  readEndpoint: PropTypes.func.isRequired
}

export default connect(null, {readEndpoint})(PreneedPaymentModal)
